'use strict';
var swig = require('swig');

function _compile(compiler, args) {
    var l = args.length,
        w = args.splice(1, l - 1).join('');

    return '_output += _ctx._this.preRenderComponent(' + w + ')' + ';\n';
}

function _parse(str, line, parser, types, stack, opts) {
    var file, w;
    parser.on(types.STRING, function (token) {
        if (!file) {
            file = token.match;
            this.out.push(file);
            return;
        }

        return true;
    });

    parser.on(types.VAR, function (token) {
        if (!file) {
            file = token.match;
            return true;
        }

        if (!w && token.match === 'with') {
            w = true;
            return;
        }

        return true;
    });

    parser.on('end', function () {
        this.out.push(null);
    });

    return true;
}

swig.setTag('include', _parse, _compile, false, false);

module.exports = swig;
